import gql from "graphql-tag";

export const DELETE_MAILINGLIST_QUERY = gql`
  mutation DeleteMailingListMutation($id: ID!) {
    deleteMailingList(where: { id: $id }) {
      id
      description
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/DeleteMailingList/queries.ts